import styled from 'styled-components';
import { Button as UIButton } from '../../../../Button/styled';
export const Button = styled(UIButton) `
    display: flex;
    flex-direction: row;
    color: white;
    align-items: center;
    z-index: 1;
`;
export const Label = styled.p `
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textSecondary) || 'white'; }};
    margin: 0 0 0 10px;
    white-space: nowrap;
`;
//# sourceMappingURL=index.js.map